@if (sourceDocumentModel) {
    <div class="main-page-area">
        <div class="main-page-content">
            <eff-step-header
                [controlGuid]="effectivenessModel.controlGuid"
                [title]="'effWorkflowSteps.uploadSourceDocuments' | t"
                (onShowInstructions)="toggleInstructions()"
                (onSaveChanges)="saveSourceDocuments(false)"
            >
            </eff-step-header>

            @if (!isUseControlExecution()) {
                <div
                    class="source-documents-label h2-title"
                    data-uiid="new-eff-upload-source-document-document-manager-header"
                >
                    {{
                        areDocumentsUploaded()
                            ? ('effTestingUploadSourceDocument.selectSourceDocument' | t)
                            : ('effTestingUploadSourceDocument.uploadDocument' | t)
                    }}
                </div>
            }
            <div data-uiid="new-eff-upload-source-document-document-manager">
                @if (!isUseControlExecution()) {
                    <document-manager-new
                        [documents]="sourceDocumentModel.documents"
                        (documentDeleted)="documentDeleted($event)"
                        [canAdd]="stepPermissions.sourceDocumentUploadAllowed"
                        [canEdit]="stepPermissions.sourceDocumentUploadAllowed"
                        [canDelete]="stepPermissions.sourceDocumentUploadAllowed"
                    ></document-manager-new>
                }
            </div>

            <div>
                @if (isUseControlExecution()) {
                    <eff-control-task-count-info-box
                        data-uiid="new-eff-task-count-info-box"
                        [effectivenessModel]="effectivenessModel"
                        [taskCounts]="taskCounts"
                    ></eff-control-task-count-info-box>
                }
            </div>

            <div>
                @if (showGenerateSamplesControlExecutionButton) {
                    <eff-button
                        [text]="'effTestingUploadSourceDocument.generateSamplesButton' | t"
                        size="large-size"
                        icon="arrow_forward"
                        iconPosition="right"
                        class="bottom-button generate-sample-usecontrolexecution-button"
                        (onClick)="openGenerateSamplePopup()"
                        data-uiid="new-eff-upload-source-document-generate-samples-button"
                    >
                    </eff-button>
                }
            </div>

            @if (isUseControlExecution() && executionData && executionData.length > 0) {
                <div data-uiid="new-eff-upload-source-document-execution-table">
                    <generic-pagination-list-manager
                        [config]="this.executionConfig"
                    ></generic-pagination-list-manager>
                </div>
            }

            <div [class]="buttonWrapperClassString">
                @if (showControlDidntOccurButton) {
                    <eff-button
                        size="large-size"
                        [text]="'effTestingUploadSourceDocument.controlDidntOccurButtonLabel' | t"
                        [class]="controlDidNotOccurButtonClassString"
                        (click)="controlDidNotOccurWithConfirmation()"
                        data-uiid="new-eff-upload-source-document-control-didnt-occur-button"
                    ></eff-button>
                }

                @if (!isUseControlExecution()) {
                    @if (stepPermissions.sourceDocumentUploadAllowed && !areDocumentsUploaded()) {
                        <eff-button
                            [text]="'effTestingUploadSourceDocument.continueWithoutSourceDocument' | t"
                            size="large-size"
                            class="bottom-button without-source-documents-btn"
                            (click)="completeSourceDocumentsWithConfirm()"
                            data-uiid="new-eff-upload-source-document-continue-without-source-document-button"
                        ></eff-button>
                    }

                    @if (stepPermissions.isCompleteAllowed && areDocumentsUploaded()) {
                        <eff-button
                            [text]="'effTestingUploadSourceDocument.generateSamplesButton' | t"
                            size="large-size"
                            class="bottom-button generate-sample-button"
                            [disabled]="!isDocumentSelected()"
                            (onClick)="openGenerateSamplePopup()"
                            data-uiid="new-eff-upload-source-document-generate-samples-button"
                        >
                        </eff-button>
                    }
                }
            </div>
        </div>

        <div class="side-page-area">
            <eff-expansion-panel
                [contentTemplate]="content"
                [title]="'effTestingUploadSourceDocument.sourceUploadInstructions' | t"
                [panelOpenState]="true"
                data-uiid="new-eff-upload-source-document-source-upload-instructions-info-box"
            >
                <ng-template #content>
                    <div
                        class="regular-text multiple-whitespaces"
                        [innerHTML]="effectivenessModel.sourceDocumentUploadInstructions"
                    ></div>
                </ng-template>
            </eff-expansion-panel>
            <eff-evidence-instructions-info-box
                [samples]="samples"
                [instructions]="effectivenessModel.evidenceUploadInstructions"
            >
            </eff-evidence-instructions-info-box>
            <eff-test-instructions-info-box
                [panelOpenState]="false"
                [samples]="samples"
                [effectivenessModel]="effectivenessModel"
            >
            </eff-test-instructions-info-box>
            <eff-control-info-box
                [controlGuid]="effectivenessModel.controlGuid"
            ></eff-control-info-box>
        </div>
    </div>
}
<cerrix-slide-over
    #cerrixSlideOver
    data-uiid="new-eff-upload-source-document-instructions-slide-over"
>
    <ng-template #title>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadSourceDocument.howToUploadSourceDocumentsTitle' | t }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadSourceDocument.howToUploadSection1Header' | t }}</div>
            <div class="content">
                {{ 'effTestingUploadSourceDocument.helpAddDocumentIntro' | t }}
            </div>
            <div class="content" [innerHTML]="'effTestingUploadSourceDocument.helpSaveChangesItem' | t"></div>
            <div class="content" [innerHTML]="'effTestingUploadSourceDocument.helpCompleteItem' | t"></div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadSourceDocument.howToUploadSection2Header' | t }}</div>
            <div class="content">
                {{ 'effTestingUploadSourceDocument.helpNoSourceDocument' | t }}
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadSourceDocument.howToUploadSection3Header' | t }}</div>
            <div class="content">
                {{ 'effTestingUploadSourceDocument.helpControlDidNotOccur' | t }}
            </div>
        </div>
    </ng-template>
</cerrix-slide-over>
